module.exports = __webpack_public_path__ + "images/102_2048.jpg";